import React, { Component } from 'react';
// import { Link } from 'gatsby';
import RelatedNews from 'src/components/RelatedNews';
import styled from '@emotion/styled';
import { iPadBreakPoint, mobileBreakPoint } from 'src/utils/ResponsiveDesign';

const Container = styled.div`
  width: 40.5%;
  ${iPadBreakPoint} {
    width: 100%;
  }
  ${mobileBreakPoint} {
    width: 100%;
  }
`;

const Content = styled.div({
  background: '#f5f5f5',
  width: '90%',
  margin: 'auto',
  paddingBottom: '20px',
});

export default class QARight extends Component {
  componentDidMount() {}

  render() {
    return (
      <Container>
        <Content>
          <RelatedNews />
        </Content>
      </Container>
    );
  }
}
